import React, { FC, useEffect } from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import { Loading } from '../../shared/components';
import { Redirect, useHistory } from 'react-router';
import { useUser } from 'src/modules/shared';
import { useI18nPath } from 'src/config/clientRoutes/hooks';
import { getTokenFromQuery } from 'src/modules/app/components/AuthorizationRoot';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';

const SsoPage: FC = () => {
  const { user } = useUser();
  const history = useHistory();
  const [subdomain] = useQueryParam('subdomain', StringParam);
  const { getPath } = useI18nPath();
  const jwt = useAppSelector((state) => state.auth.jwt);
  const { target_uri } = getTokenFromQuery(window.location.search);

  useEffect(() => {
    if (user && !user.privacyAcceptedAt) history.push(getPath('cookieCompliance'));
  }, [user, history, getPath]);

  useEffect(() => {
    if (subdomain && subdomain !== '?') {
      const redirectURL = (process.env.REACT_APP_SSO_URL || '')
        .replace('domain', subdomain)
        .replace('api_root', process.env.REACT_APP_API_ROOT_V2 || '');
      const absoluteURL = new URL(redirectURL, window.location.origin).href;
      setTimeout(() => {
        window.location.href = absoluteURL;
      }, 0);
    }
  }, [subdomain]);

  console.log('SsoPage');

  if (jwt) return null;

  if (!subdomain)
    return (
      <div style={{ width: 300, height: 300 }}>
        <Loading />
      </div>
    );
  else return <Redirect to={target_uri ?? '/'} push={false} />;
};

export default SsoPage;
